module.exports = __webpack_public_path__ + "static/media/af.81ea5c11.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/af.svg
// module id = 2029
// module chunks = 0